import React, { useEffect, useReducer, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server from "../../api/server";
import axios from "axios";
import { toast } from "react-toastify";

const FeaturesShow = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { featureID } = useParams();
	const [loading, setLoading] = useState(false);
	const [, forceUpdate] = useReducer(x => x + 1, 0);

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		getValues,
		reset,
	} = useForm();

	const fetchFeature = async () => {
		setLoading(true);
		try {
			const { data } = await server(cookie).get(
				`/pages/features/sections/${featureID}`
			);
			if (data?.data?.section) {
				reset(data.data.section);
			}
		} catch (error) {
			toast.error("فشل في تحميل البيانات!");
		}
		setLoading(false);
	};

	const handleImageUpload = async event => {
		setLoading(true);
		const file = event.target.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);
			setValue("icon", response.data.data.file.path);
			toast.success("تم رفع الصورة!");
		} catch (error) {
			toast.error("خطأ في رفع الصورة!");
		} finally {
			setLoading(false);
			forceUpdate();
		}
	};

	const onSubmit = async formData => {
		setLoading(true);
		try {
			const updatedData = {
				title: "features",
				name: formData.name,
				icon: formData.icon,
			};

			await server(cookie).put(`/pages/project/sections/${featureID}`, {
				section: updatedData,
			});

			toast.success("تم تحديث البيانات!");
			history.push("/features/index");
		} catch (error) {
			toast.error("حدث خطأ أثناء التحديث");
		}
		setLoading(false);
	};

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "تعديل الميزة",
				breadcrumb: "المميزات",
				button: { show: false, text: null, link: null },
			})
		);
		fetchFeature();
	}, [featureID]);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className="row">
					<div className="col-md-12" style={{ height: 50 }} />

					<div className="col-md-4">
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="picture">البانر</label>
								<input type="file" id="picture" onChange={handleImageUpload} />
								<input type="hidden" {...register("icon")} />
								<img
									src={
										getValues("icon")
											? `${process.env.REACT_APP_MAIN_URL}/${getValues("icon")}`
											: userPlaceholder
									}
									alt="preview"
									className="imagePreview"
								/>
							</div>
						</div>
					</div>

					<div className="col-md-8">
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="featureAr">ميزة باللغة العربية</label>
								<input
									type="text"
									id="featureAr"
									{...register("name.ar", { required: true })}
								/>
							</div>
							<div className="form-item">
								<label htmlFor="featureEn">ميزة باللغة الانجليزية</label>
								<input
									type="text"
									id="featureEn"
									{...register("name.en", { required: true })}
								/>
							</div>
						</div>
					</div>

					<div className="col-md-12" style={{ height: 50 }} />
					<div className="col-md-12">
						<div className="form-item mt-3">
							<button type="submit" className="bt bt-success btn-block">
								تحديث
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default FeaturesShow;
